const envConfig = {
  VITE_API_BUSINESS_URL: import.meta.env.VITE_API_BUSINESS_URL,
  VITE_BOOM_APP_ID: import.meta.env.VITE_BOOM_APP_ID,
  VITE_BOOM_CLIENT_ID: import.meta.env.VITE_BOOM_CLIENT_ID,
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  VITE_RPC_URL: import.meta.env.VITE_RPC_URL,
  VITE_CLIENT_WS_URL: import.meta.env.VITE_CLIENT_WS_URL,
  VITE_API_SMART_URL: import.meta.env.VITE_API_SMART_URL,
  VITE_CLIENT_WS_SMART_URL: import.meta.env.VITE_CLIENT_WS_SMART_URL,
};

export default envConfig;
